<template>
  <gc-main-layout :title="title" :isXSmall="isXSmall" :isLarge="isLarge">
    <div></div>
  </gc-main-layout>
</template>
<script>
import BaseViewMixin from "../v1/_mixins/base.view";

export default {
  props: {},
  data() {
    return {};
  },

  mixins: [BaseViewMixin],
  created() {
    if (this.baseView.query.url) {
      this.$router.push({
        path: this.baseView.query.url,
      });
    } else {
      this.$router.push({
        path: "/home",
      });
    }
  },
};
</script>
